import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import {
  getInitialLoadIcons,
  ZeeFontBold,
  ZeeFontMedium,
  ZeeFontRegular
} from 'src/styles/font';
import { flex } from 'src/styles/utils';
import { InitialLoadIconsSet } from 'src/utils/constants/IconsConstants';

import { MediaBP as MQ } from '../../../../../src/styles/mediaQuery';

export const errorPopupContent = css`
  color: #f2f2f2;
  background-color: #333333;
  border-radius: 6px;
  margin: 0 auto;
  padding: 20px;
  position: relative;
  top: 55%;
  width: 290px;
  transform: translateY(12%);

  /* width */
  ::-webkit-scrollbar {
    width: 5px;
    border-radius: 5px;
    background-color: transparent;
    opacity: 0.8;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    padding: 2px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    opacity: 0.8;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: hsla(0, 0%, 100%, 0.3);
    border-radius: 4px;
    opacity: 0.8;
  }

  @media screen and (max-device-width: 1024px) and (orientation: landscape) {
    height: 265px;
    overflow-y: scroll;
  }
  ${MQ.MediaMd} {
    padding: 24px;
    width: 310px;
    transform: translateY(-25%);
  }

  ${MQ.MediaLg} {
    right: 240px;
    padding: 32px;
    width: 340px;
    top: 50%;
    transform: translateY(22%);
    height: 370px;
    overflow-y: scroll;
  }
`;

export const closeContainer = css`
  ${getInitialLoadIcons(InitialLoadIconsSet.CLOSE, false)}
  color: #BDBDBD;
  ${ZeeFontRegular(28, 28)};
  position: absolute;
  top: 16px;
  right: 16px;

  ${MQ.MediaLg} {
    ${ZeeFontRegular(32, 32)};
    top: 30px;
    right: 20px;
  }

  &:hover {
    color: ${colors.PrimaryWhiteColor};
    text-decoration: none;
    cursor: pointer;
  }
`;
export const popupTitle = css`
  ${ZeeFontBold(14, 20)};

  ${MQ.MediaLg} {
    ${ZeeFontBold(18, 26)};
  }
`;
export const popupSubTitle = css`
  ${ZeeFontMedium(12, 18)};
  padding-top: 18px;

  ${MQ.MediaLg} {
    ${ZeeFontMedium(16, 22)};
  }
`;
export const uiNetworkErrorList = css`
  list-style: inherit;
  list-style-position: outside;
  color: #bdbdbd;
  padding-top: 2px;
  padding-left: 20px;
`;
export const liNetworkErrorList = css`
  padding: 2px 6px;
  ${ZeeFontRegular(12, 16)};
`;

const commonButtonStyles = css`
  border-radius: 4px;
  cursor: pointer;
  border: none;
  padding: 8px 14px;
  color: ${colors.white};
  ${ZeeFontBold(12, 15)};
  width: 128px;
  ${MQ.MediaMd} {
    ${ZeeFontBold(16, 22)};
    width: 182px;
    padding: 12px 24px;
  }
  ${MQ.MediaLg} {
    ${ZeeFontBold(12, 15)};
    width: 128px;
    padding: 8px 12px;
  }
  ${MQ.MediaXl} {
    border-radius: 6px;
  }
`;
export const buyPremiumButton = css`
  ${commonButtonStyles}
  background: ${colors.PurpleBtn};
`;

export const viewAllButton = css`
  ${commonButtonStyles}
  background: none;
  border: 1px solid ${colors.white};
`;

export const newSvodContainer = css`
  position: relative;
  width: 100%;
  height: 100%;
  ${flex()};
`;

export const svodText = css`
  ${ZeeFontRegular(12, 16)}
  width: 140px;
  ${MQ.MediaMd} {
    width: 100%;
    ${ZeeFontMedium(16, 22)};
  }
  ${MQ.MediaLg} {
    ${ZeeFontRegular(12, 16)}
  }
  ${MQ.MediaXl} {
    ${ZeeFontMedium(16, 22)};
  }
`;

export const svodButtonContainer = css`
  ${flex('column-reverse')};
  gap: 16px;
  ${MQ.MediaMd} {
    ${flex('row-reverse')};
  }
`;

export const newSvodGradient = css`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    270deg,
    rgba(0, 0, 0, 0) 0.18%,
    rgba(0, 0, 0, 0.97) 64.48%,
    #000 99.84%
  );
`;

export const wrapperDiv = css`
  width: 100%;
  height: 100%;
  z-index: 1;
  ${flex('column', 'center', 'start')}
  gap: 16px;
  padding-left: 20px;
  ${MQ.MediaSm} {
    padding-left: 40px;
  }
`;
export const newSvodPopupImage = css`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;
export const imageContainer = css`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;
